/**
 * Utility functions for Monaco Editor
 */

/**
 * Map file extensions to Monaco language identifiers
 * @param {string} path - File path
 * @returns {string} Monaco language identifier
 */
export function getLanguage(path) {
  if (!path) return 'plaintext';

  const ext = path.split('.').pop()?.toLowerCase() || '';

  const langMap = {
    'js': 'javascript',
    'jsx': 'javascript',
    'ts': 'typescript',
    'tsx': 'typescript',
    'py': 'python',
    'java': 'java',
    'cpp': 'cpp',
    'c': 'c',
    'h': 'c',
    'html': 'html',
    'htm': 'html',
    'css': 'css',
    'scss': 'scss',
    'less': 'less',
    'json': 'json',
    'xml': 'xml',
    'md': 'markdown',
    'sh': 'shell',
    'bash': 'shell',
    'yaml': 'yaml',
    'yml': 'yaml',
    'sql': 'sql',
    'go': 'go',
    'rs': 'rust',
    'rb': 'ruby',
    'php': 'php',
    'swift': 'swift',
    'kt': 'kotlin',
    'scala': 'scala',
    'r': 'r',
    'm': 'objective-c',
    'mm': 'objective-c',
    'vue': 'html',
    'svelte': 'html'
  };

  return langMap[ext] || 'plaintext';
}
